export default __webpack_public_path__ + "static/media/ecogflogo-p-500.5c7732de.png";